module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-it.3965f0b9.mp4";